import { render, staticRenderFns } from "./form-create-new-student.vue?vue&type=template&id=8a6c809a&"
import script from "./form-create-new-student.vue?vue&type=script&lang=js&"
export * from "./form-create-new-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports